import nestAxios from './_nestAxios'

export const obtenerStockEnSedes = idProductoPresentacion =>
  nestAxios.get('/stock/stock-sedes', {
    params: { idProductoPresentacion }
  })

export const recalcular = () => nestAxios.post('/stock/recalcular')

export const obtenerStocksPasado = () => nestAxios.post('/stock/copiar-stock-pasado')

